import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import Num2persian from 'num2persian';


@Component({
  selector: 'app-ckd-invoice2',
  templateUrl: './ckd-invoice2.component.html',
  styleUrls: ['./ckd-invoice2.component.scss']
})
export class CkdInvoice2Component implements OnInit, OnDestroy {
  public loading = false;
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang: any = 1;
  public user_id: number | undefined;
  public subscription: Subscription | any;
  public server: any = this.serverService.get_server();
  public reception_id: number | undefined;
  public code: number | undefined;
  public sum_tax: number = 0;
  public sum_with_discount: number = 0;
  public currency_title: string = 'ریال';
  public logo: string = "https://hooshmandsazeh.com/object/images/logohoshfa.png";
  public store_title = "هوشمند سازه آروین آرا";
  public store_phone = "021-4579";
  public store_address = "تهران، جلال آل احمد، پلاک ۴۱۷";
  public id: number;
  public contract: string;
  public date: string | undefined;
  public time: string | undefined;
  public device_title: number | undefined;
  public cellphone: number | undefined;
  public brand_title: number | undefined;
  public model_title: number | undefined;
  public searial: number | undefined;
  public user_title: number | undefined;
  public user_address: number | undefined;
  public status_title: any | undefined;
  public status_id: any | undefined;
  public sex_title: string | undefined;
  public belong2_title: string | undefined;
  public objections2_title: string | undefined;
  public editor_date: string | undefined;
  public logo_company_sign: string | undefined;
  public date2: string | undefined;
  public date_ad: string | undefined;
  public date2_ad: string | undefined;
  public user_cellphone: string | undefined;
  public user_phone: string | undefined;
  public sum: number = 0;
  public list_material: any = [];
  public sum_all: number = 0;
  public sum_final: number = 0;
  public discount_all: number = 0;
  public sum_all_letter: string | undefined;
  public rstatus_empty_shelf: boolean | undefined;
  public footer: string | undefined;
  public rule_site: string | undefined;
  public height: string | undefined;
  public width: string | undefined;
  public logo_status: boolean = false;
  public bg: string | undefined;
  public sign: string | undefined;
  public user1_id: number | undefined;
  public remain: number = 0;
  public balance: number = 0;
  public list_attachment: any = [];
  public seleton_id: number | undefined;
  public meter: number;
  public show_discount: boolean = false;


  constructor(
    public serverService: ServerService
    , public router: Router
    , public matSnackBar: MatSnackBar
    , public activatedRoute: ActivatedRoute) { }//end consructor

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.reception_id = params['id'];
        this.code = params['token'];
      }
    )
    this.get_reception();
  }

  get_reception() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = { address: 10590, id: this.reception_id, code: this.code }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.id = res['result'][0].site_ckd_id;
          this.seleton_id = res['result'][0].site_ckd_seleton_id;
          this.user_cellphone = res['result'][0].user_cellphone;
          this.contract = res['result'][0].site_ckd_contract;
          this.user1_id = res['result'][0].user_id;
          this.user_title = res['result'][0].user_title;
          this.user_address = res['result'][0].user_address;
          this.user_phone = res['result'][0].user_phone;
          this.date = res['result'][0].site_ckd_date;
          this.date2 = res['result'][0].site_ckd_date2;
          this.time = res['result'][0].site_ckd_time;
          this.status_title = res['result'][0].ckd_status_title;
          this.sex_title = res['result'][0].user_sex_title;
          this.sign = res['result'][0].sign;
          this.footer = this.store_title + " " + this.store_phone;
          this.rule_site = res['result'][0].user_rule_site;
          this.editor_date = res['result'][0].repairman_reception_editor_time + " " + res['result'][0].repairman_reception_editor_date;
          this.bg = res['result'][0].user_bg_logo;
          this.get_balance();
          this.get_material();
          this.get_meter();

          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  get_meter() {
    var obj = { address: 10647, code: this.code }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.meter = res['result'][0].pre_factor_lsf_order_meter;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_balance() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1731, user: this.user1_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.remain = res['result'][0].balance;
            this.balance = res['result'][0].balance - this.sum_all;
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_material() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10570, ckd_id: this.id, seleton_id: this.seleton_id }).subscribe(
      (res: any) => {
        this.sum_final = 0;
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {


            res['result'][i].sum_with_discount = res['result'][i].sum_all - res['result'][i].wharehouse_order_discount;
            res['result'][i].tax = Math.round(res['result'][i].sum_with_discount * 9 / 100);
            res['result'][i].sum_final = res['result'][i].sum_with_discount + res['result'][i].tax;

            this.sum_all = this.sum_all + res['result'][i].sum_all;
            this.sum_tax = this.sum_tax + res['result'][i].tax;
            this.sum_final = this.sum_final + res['result'][i].sum_final;
            this.discount_all = this.discount_all + res['result'][i].wharehouse_order_discount;
            this.sum_with_discount = this.sum_with_discount + res['result'][i].sum_with_discount;
            if (res['result'][i].wharehouse_order_discount > 0) {
              this.show_discount = true;
            }

            this.list_material.push(res['result'][i]);
          }
          this.sum_all_letter = Num2persian(this.sum_final);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 5000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}